module.exports = __webpack_public_path__ + "img/05.6dc29950.jpg";